import React, { useState } from "react";

import modStyl from './index.module.scss'
import { Toast } from "antd-mobile";

type TabItem = {
  key: number,
  label: string,
  value: number
}

type Props = {

}

const Task: React.FC<Props> = (props) => {
  const [tabs, setTabs] = useState([
    {key: 1, label: '入组确认', value: 3},
    {key: 2, label: '不良反应', value: 2},
    {key: 3, label: '其他', value: 2},
  ])

  const data = [
    {id: 1, name: '张三'},
    {id: 2, name: '李四'},
    {id: 3, name: '王五'},
  ]

  const [current, setCurrent] = useState<TabItem>({
    key: 1,
    label: '入组确认',
    value: 3
  })

  const upcoming = () => Toast.show('敬请期待')

  return (
    <div className={modStyl.wrapper}>
      <div className={modStyl.tabContiner}>
        {
          tabs.map((item)=> (
            <button onClick={()=> setCurrent(item)} className={current.key === item.key ? modStyl.active : ''} key={item.key} type="button">{item.label}({item.value})</button>
          ))
        }
      </div>
      <div className={modStyl.listContainer}>
        {
          data.splice(0, current.value).map(({id, name}, index)=> (
            <div className={modStyl.item} key={id}>
              <div className={modStyl.west}>
                {
                  current.key > 1 && (
                    <h2>{current.key === 2 ? '用药反馈' : ['患者转院', '外院反馈'][index]}</h2>
                  )
                }
                <p className={current.key === 1 ? modStyl.ufirst : ''}>
                  <span>{name}</span>
                  <span>男</span>
                  <span>患者本人</span>
                </p>
              </div>
              <div className={modStyl.east}>
                {
                  current.key === 1 && (
                    <>
                    <button onClick={upcoming} type="button">拒绝入组</button>
                    <button onClick={upcoming} type="button" className={modStyl.primary}>通过入组</button>
                    </>
                  )
                }
                {
                  current.key > 1 && (
                    <button onClick={upcoming} type="button">查看详情</button>
                  )
                }
              </div>
            </div>
          ))
        }
      </div>
    </div>
  )
}

export default Task